import React from "react";
import { useFileUploadInfoData } from "../Contexts/fileUploadInfoProvider";
import "./sidenav.css";

interface Props {
  displayBOList: boolean;
  setSelectedPage: React.Dispatch<React.SetStateAction<string>>;
  setSelectedCountry: React.Dispatch<React.SetStateAction<string>>;
  setSelectedOption: React.Dispatch<React.SetStateAction<string>>;
  selectedPage: string;
  selectedCountry: string;
  selectedOption: string;
  env: string;
}

const Sidenav: React.FC<Props> = (props) => {  
  const {
    displayBOList,
    selectedCountry,
    selectedOption,
    setSelectedOption,
    setSelectedPage,
    setSelectedCountry,
    env
  } = props;

  //use of context FileUploadInfoProvider
  const {fileUploadData, setUploadData } = useFileUploadInfoData();

  const handleButtonClick = (event: React.MouseEvent<HTMLElement>) => {    
    //When country is changed then reset the Upload Data
    if (env !== "Development") {
      setUploadData({});
    }

    if (event.currentTarget.id === "Germany") {
      if (selectedCountry === "Germany") {
        setSelectedCountry((prevSelCtry) => (prevSelCtry = ""));
        setSelectedOption((prevSelOpt) => (prevSelOpt = ""));
        setSelectedPage(prevSelPage => prevSelPage = "MarketSelection");
      } else  {        
        setSelectedCountry((prevSelCtry) => (prevSelCtry = "Germany"));
        setSelectedPage(prevSelPage => prevSelPage = "GermanOptions");
      }        
    } else if (
      event.currentTarget.id === "German Tax Voucher" ||
      event.currentTarget.id === "German Tax Breakdown" ||
      event.currentTarget.id === "German Reporting Standing Instruction InvStG"
    ) {
      setSelectedPage("Acknowledgement");
      setSelectedCountry("Germany");
      setSelectedOption(event.currentTarget.id);      
    } else {
      setSelectedOption((prevSelOpt) => (prevSelOpt = ""));
      setSelectedPage("Acknowledgement");      
      setSelectedCountry(event.currentTarget.id);      
    }
  };

  return (
    <>
      {displayBOList ? (
        <nav id="nav-secondary" className="grid-2">
          <h2>BO Lists</h2>
          <ul>
            <li>
              <button id="Germany" onClick={handleButtonClick}>
                Germany
              </button>
              <ul
                style={{
                  display: `${selectedCountry !== "Germany" ? "none" : ""}`,
                }}
              >
                <li
                  className={`${
                    selectedOption === "German Tax Voucher" && "active"
                  }`}
                >
                  <button id="German Tax Voucher" onClick={handleButtonClick}>
                    Tax Voucher
                  </button>
                </li>
                <li
                  className={`${
                    selectedOption === "German Tax Breakdown" && "active"
                  }`}
                >
                  <button id="German Tax Breakdown" onClick={handleButtonClick}>
                    Tax Breakdown
                  </button>
                </li>
                <li
                  className={`${
                    selectedOption ===
                      "German Reporting Standing Instruction InvStG" && "active"
                  }`}
                >
                  <button
                    id="German Reporting Standing Instruction InvStG"
                    onClick={handleButtonClick}
                  >
                    Reporting Standing
                    <br />
                    Instruction InvStG
                  </button>
                </li>
              </ul>
            </li>
          </ul>
          <ul>
            <li className={`empty ${selectedCountry === "Italy" && "active"}`}>
              <button id="Italy" onClick={handleButtonClick}>
                Italy
              </button>
            </li>
          </ul>
          <ul>
            <li className={`empty ${selectedCountry === "Japan" && "active"}`}>
              <button id="Japan" onClick={handleButtonClick}>
                Japan
              </button>
            </li>
          </ul>
          <ul>
            <li
              className={`empty ${
                selectedCountry === "South Korea" && "active"}`}
            >
              <button id="South Korea" onClick={handleButtonClick}>
                South Korea
              </button>
            </li>
          </ul>
          <ul>
            <li className={`empty ${selectedCountry === "Spain" && "active"}`}>
              <button id="Spain" onClick={handleButtonClick}>
                Spain
              </button>
            </li>
          </ul>
          <ul>
            <li
              className={`empty ${selectedCountry === "Singapore" && "active"}`}
            >
              <button id="Singapore" onClick={handleButtonClick}>
                Singapore
              </button>
            </li>
          </ul>
        </nav>
      ) : (
        <nav id="nav-secondary" className="grid-2" />
      )}
    </>
  );
};

export default Sidenav;
